import React, { useState } from 'react'
import { IconButton, Icon, Message } from 'rsuite'

export default function CustomAlertMessage(props) {
  const { contents, title } = props
  const [isShow, setIsShow] = useState(true)
  const type = 'info'

  return (
    <>
      {contents?.length > 0 && (
        <div>
          <IconButton
            color="orange"
            icon={<Icon appearance="ghost" icon="info" />}
            onClick={() => {
              setIsShow(!isShow)
            }}
          />
          <span
            style={{ color: 'orange', cursor: 'pointer', marginLeft: 10 }}
            onClick={() => {
              setIsShow(!isShow)
            }}
          >
            {title || 'คำอธิบายการกรอกข้อมูล'}
          </span>
          {isShow && (
            <div style={{ marginTop: 10 }}>
              {contents?.map((item, index) => {
                return (
                  <Message
                    key={`${item.id}`}
                    showIcon
                    type={item.msgTypeName || type}
                    description={<span dangerouslySetInnerHTML={{ __html: item.msg }} />}
                    style={{ marginBottom: 10 }}
                  />
                )
              })}
            </div>
          )}
        </div>
      )}
    </>
  )
}
